import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./home/homePage";
import WorkPage from "./work/workPage";
import ContactPage from "./contact/contactPage";
import AboutPage from "./about/aboutPage";
import UserProvider from "./context/userContext";
import WebProjects from "./work/webProjects";
import PythonProjects from "./work/pythonProjects";


function App() {
  return (
    <>
      <UserProvider>
        <BrowserRouter>
          <Routes>
            <Route exact path="/" element={<HomePage />}></Route>

            <Route exact path="work" element={<WorkPage />}></Route>

            <Route exact path="aboutMe" element={<AboutPage />}></Route>

            <Route exact path="contactMe" element={<ContactPage />}></Route>

            <Route path="/web-projects" element={<WebProjects />} />
            <Route path="/python-projects" element={<PythonProjects />} />
            
          </Routes>
        </BrowserRouter>
      </UserProvider>
    </>
  );
}

export default App;
